import { Component, OnInit, Input, EventEmitter, Output, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { find } from 'lodash';
import {
  OptionsColumns,
  Option,
  ColumnaMaestra,
  FiltrosSelectores,
  BaseControl,
  ConfirmComponent
} from '@app/shared';
import { FiltersFormMasterFormConfigService } from './shared/filters-form-master.config.service';
import { FiltersFormMasterFormService } from './shared/filters-form-master.form.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-filters-form-master',
  templateUrl: './filters-form-master.component.html',
  styleUrls: ['./filters-form-master.component.scss'],
  providers: [FiltersFormMasterFormService]
})
export class FiltersFormMasterComponent implements OnInit, OnDestroy {

  // Contiene el formulario del control
  @Input() formulario: Array<ColumnaMaestra> = [];
  // Contiene el control a operar
  @Input() control: ColumnaMaestra;
  // Contiene la informacion de las diferentes columnas de la maestra seleccionada
  @Input() columnsMaster: Array<OptionsColumns> = [];
  // String que identifica la accion a realizar
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Contiene el index del filtro seleccionado para editar
  indexFilterSelect = -1;
// Define si la accion a realizr es un modificar o un agregar
  update = false;
  // Define cuando se muestra el formulario para agregar o modificar un filtro
  formFilter = false;
  // Contiene toodas las formas inplicadas en la forma actual e incluyendo esta
  allFields: Array<Option> = [];
  // Contiene los tipos de operadores
  optOperatios: Option[] = [
    {key: '=', value: 'Igual'},
    {key: '!=', value: 'Diferente'},
    {key: '>', value: 'Mayor'},
    {key: '>=', value: 'Mayor Igual'},
    {key: '<', value: 'Menor'},
    {key: '<=', value: 'Menor Igual'},
    {key: 'IN', value: 'IN'},
    {key: 'NOT IN', value: 'NOT IN'},
    {key: 'ILIKE', value: 'ILIKE'},
    {key: 'ILIKE ANY', value: 'ILIKE ANY'},
    {key: 'LIKE', value: 'LIKE'},
    {key: 'IS NULL', value: 'IS NULL'},
    {key: 'IS NOT NULL', value: 'IS NOT NULL'},
  ];
  // Filtro de los selectores
  controlFilters: Array<FiltrosSelectores> = [];
  // Contiene los controles del formulario para agregar los campos
  controls: BaseControl<any>[] = [];
  // Contiene temporalmente la configuracion del valor de la referencia
  tmpControlOperationsValue: FiltrosSelectores;
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Configuracion de la tabla
  settings = {};
  // Templates de los selects de el formulario de creacion o edicion de selects
  templatesSelects = {};
  // Contiene las opciones del formulario de los ngSelects para las tablas de formas
  options: any = {};
  // Contiene los nombres de los tipos de operaciones
  operations = {};
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select para las columnas del filtro
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select para las columnas del filtro
  @ViewChild('ngSelectGeneral') ngSelectGeneral: TemplateRef<any>;
  // Salida de los filtros agregados al control
  @Output() filters: EventEmitter<Array<any>> = new EventEmitter();

  constructor(
    private ffmfs: FiltersFormMasterFormService,
  ) { }

  ngOnInit() {
    if (this.formulario && this.formulario.length) {
      this.formulario.forEach(column => {
        this.allFields.push({
          key: column.alias,
          value: column.alias
        });
      });
    }
    if (this.optOperatios.length) {
      this.optOperatios.forEach(operation => {
        this.operations[operation.key] = operation.value;
      });
    }

    if (this.control && this.control.validaciones) {
      if (this.control.validaciones.filtros && this.control.validaciones.filtros.length) {
        this.control.validaciones.filtros.forEach(filter => {
          this.controlFilters.push({
            columna: filter.columna,
            field: filter.field,
            validarCampo: filter && filter.validarCampo ? filter.validarCampo : null,
            valor: filter.valor,
            operador: filter.operador,
            condicional: filter.condicional
          });
        });
        this.loadingFilters();
      }
    }
    const configTable = new FiltersFormMasterFormConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.openFormFilter(res.action, res.data);
    });
    this.templatesSelects = {
      ngSelectTpl: this.ngSelectTpl,
      ngSelectGeneral: this.ngSelectGeneral
    };
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Abre el formulario de agregar o editar filtro
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof FiltersFormMasterComponent
   */
  openFormFilter(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    this.options = {
      columns: this.columnsMaster,
      optOperatios: this.optOperatios,
      fields: this.allFields
    };
    switch (action) {
      case 'update':
        if (data && data.index >= 0) {
          this.actionForm = 'Modificar';
          this.update = true;
          this.indexFilterSelect = data.index;
          this.tmpControlOperationsValue = {
            columna: data.columna,
            field: data.field,
            valor: data.valor,
            condicional: data.condicional,
            operador: data.operador,
          };
          this.formFilter = true;
          this.controls = this.ffmfs.getFormFilter(this.options, this.templatesSelects, data);
        }
        break;
      case 'delete':
        if (data && data.index >= 0) {
          this.indexFilterSelect = data.index;
          this.update = false;
          this.question = '¿Realmente desea eliminar el filtro?';
          this.confirm.open();
        }
        break;
      default:
        this.update = false;
        this.actionForm = 'Agregar';
        this.controls = this.ffmfs.getFormFilter(this.options, this.templatesSelects);
        this.formFilter = true;
        break;
    }
  }

  /**
   * Cierra el formulario de agregar o editar filtro
   *
   * @memberof FiltersFormMasterComponent
   */
  closeFormFilter() {
    this.actionForm = '';
    this.options = {};
    this.controls = [];
    this.indexFilterSelect = -1;
    this.formFilter = false;
  }

  /**
   * Controla el modal de confirmaciones
   *
   * @param {boolean} res
   * @memberof FiltersFormMasterComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteFilter(this.indexFilterSelect);
    }
    this.question = '';
  }

  /**
   * Guarda o edita el filtro dependiendo de la accion del formulario
   *
   * @param {*} data
   * @memberof FiltersFormMasterComponent
   */
  save(data: any) {
    if (this.update) {
      this.controlFilters.forEach((filter, indexOpr) => {
        if (filter.index === this.indexFilterSelect) {
          this.controlFilters[this.indexFilterSelect] = {
            columna: data.cboColumn,
            form: data.cboForm,
            formulario: data.cboFormulario,
            field: data.cboField,
            valor: data.txtValor ? data.txtValor : ' ',
            index: this.indexFilterSelect,
            condicional: data.cboconditional,
            operador: data.cboOperador,
          };
          this.loadingFilters();
        }
      });
      this.update = false;
    } else {
      this.controlFilters.push({
        columna: data.cboColumn,
        field: data.cboField,
        valor: data.txtValor ? data.txtValor : ' ',
        index: this.controlFilters.length,
        condicional: data.cboconditional,
        operador: data.cboOperador,
      });
      this.loadingFilters();
    }
    this.closeFormFilter();
  }

  /**
   * Elimina un filtro de la lista
   *
   * @private
   * @param {number} index
   * @memberof FiltersFormMasterComponent
   */
  private deleteFilter(index: number) {
    this.controlFilters.forEach((filter, indexOpr) => {
      if (filter.index === index) {
        this.controlFilters.splice(indexOpr, 1);
        this.loadingFilters();
      }
    });
  }

  /**
   * Carga los filtros del control
   *
   * @private
   * @memberof FiltersFormMasterComponent
   */
  private loadingFilters() {
    this.controlFilters.forEach((filter, index) => {
      filter.index = index;
      const textColumn = find(this.columnsMaster, {value: filter.columna});
      if (textColumn) {
        filter['textColum'] = textColumn.key;
      }

      filter['textOperacion'] = this.operations[filter.operador];

    });
    this.sourceData = new LocalDataSource(this.controlFilters);
    this.purgeFilters(this.controlFilters);
    this.sourceData.refresh();
  }

  /**
   * Purga la lista de filtros para ser retornada
   *
   * @private
   * @param {FiltrosSelectores[]} controlFilters
   * @memberof FiltersFormMasterComponent
   */
  private purgeFilters(controlFilters: FiltrosSelectores[]) {
    const newControlFilters: FiltrosSelectores[] = [];
    if (controlFilters && controlFilters.length) {
      controlFilters.forEach(filter => {
        newControlFilters.push({
          columna: filter.columna,
          field: filter.field,
          validarCampo: filter && filter.validarCampo ? filter.validarCampo : null,
          valor: filter.valor ? filter.valor : ' ',
          index: filter.index,
          operador: filter.operador,
          condicional: filter.condicional
        });
      });
    }
    this.filters.emit(newControlFilters);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/master-structure/filters-form-master/filters-form-master.component.ts